module.exports = __webpack_public_path__ + "static/media/slide1.c73c5536.png";